import { ArrowRight } from "lucide-react";

export default function CTA() {
  return (
    <section className="bg-slate-950 py-32">

      <div className="container mx-auto px-6">

        <div className="rounded-[40px] bg-gradient-to-r from-cyan-500 to-blue-600 p-16 text-center">

          <h2 className="text-5xl font-bold text-white">

            Ready to Transform Learning?

          </h2>

          <p className="text-cyan-100 mt-6 text-lg">

            Empower your workforce with an AI-powered learning platform.

          </p>

          <button className="mt-10 bg-white text-slate-900 rounded-xl px-8 py-4 font-semibold inline-flex items-center gap-3">

            Get Started

            <ArrowRight size={18} />

          </button>

        </div>

      </div>

    </section>
  );
}